import { withSagaCancelSignal } from 'features/common/state/sagaUtils'
import { getWithConditionalRetry } from 'features/common/api/utils'

import { JobStatusType } from '../types'
import { shouldRetryJobOnError } from '../utils'
import { isPendingOrRunning } from '../models/jobs'
import { POLLING_INTERVAL } from './jobConstants'

export function* pollJobUntilFinished<T extends { status: JobStatusType }>(checkJob: () => Promise<T>) {
  return yield withSagaCancelSignal((signal) =>
    getWithConditionalRetry({
      get: checkJob,
      shouldRetry: (result) => isPendingOrRunning(result.status),
      shouldRetryError: shouldRetryJobOnError,
      interval: POLLING_INTERVAL,
      signal
    })
  )
}
